<template>
  <div :class="['modal', { 'is-active': show }]">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Update Appointment</p>
        <button class="delete" @click="$emit('hide')"></button>
      </header>
      <section class="modal-card-body">
        <schedule-form
          :encounter="encounter"
          :errors="errors"
          label="Update"
          :onSubmit="onSubmit"
          :showDelete="true"
          :deleteLoading="deleteLoading"
          @delete="onDelete"
          @hide="$emit('hide')"
          :edit="true"
        >
        </schedule-form>
        <vue-toastr ref="toastr"></vue-toastr>
      </section>
    </div>
  </div>
</template>

<script>
/* eslint func-names: ["error", "never"] */

import EncountersService from "@/services/EncountersService";
import ScheduleForm from "./ScheduleForm";

export default {
  name: "schedule-edit",

  props: ["encounter"],

  components: {
    ScheduleForm
  },

  data() {
    return {
      loading: false,
      deleteLoading: false,
      errors: {}
    };
  },

  computed: {
    show() {
      return this.$store.getters["encounter/showScheduler"];
    }
  },

  methods: {
    onSubmit(formValues) {
      this.loading = true;

      EncountersService.update(formValues)
        .then(() => {
          this.loading = false;
          this.$refs.toastr.s("The visit has been updated.");
          this.$emit("updated");
          this.$emit("hide");
        })
        .catch(errors => {
          this.loading = false;
          const e = errors.response.data.errors[0].detail[0];
          this.$refs.toastr.e(e.detail);
        });
    },
    onDelete() {
      this.deleteLoading = true;
      EncountersService.delete(this.encounter.id).then(() => {
        this.deleteLoading = false;
        this.$refs.toastr.s("The visit has been deleted.");
        setTimeout(() => {
          this.$emit("updated");
          this.$emit("hide");
        }, 500);
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
